export const endpoints = [
  // Tool-Enabled Chat endpoints
  { value: '/api/toolchat/gpt-4-turbo', label: 'GPT-4 Turbo' },
  { value: '/api/toolchat/gpt-4o', label: 'GPT-4o' },
  { value: '/api/toolchat/gpt-4o-mini', label: 'GPT-4o-mini' },
  { value: '/api/toolchat/gpt-4.1', label: 'GPT-4.1' },
  { value: '/api/toolchat/gpt-5', label: 'GPT-5' },
  { value: '/api/toolchat/o1', label: 'o1' },
  { value: '/api/toolchat/o3', label: 'o3' },
  { value: '/api/toolchat/o3-mini', label: 'o3-mini' },
  { value: '/api/toolchat/o4-mini', label: 'o4-mini' },
];

export const endpointMapping = {
  // Tool-Enabled Chat endpoint mappings
  '/api/toolchat/gpt-4-turbo': 'GPT-4 Turbo',
  '/api/toolchat/gpt-4o': 'GPT-4o',
  '/api/toolchat/gpt-4o-mini': 'GPT-4o-mini',
  '/api/toolchat/gpt-4.1': 'GPT-4.1',
  '/api/toolchat/gpt-5': 'GPT-5',
  '/api/toolchat/o1': 'o1',
  '/api/toolchat/o3': 'o3',
  '/api/toolchat/o3-mini': 'o3-mini',
  '/api/toolchat/o4-mini': 'o4-mini',
};
  
  export const getLlmName = (endpoint) =>
    endpointMapping[endpoint] || 'Unknown LLM';
